/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerCancelWaitingListRequest } from '../models/CustomerCancelWaitingListRequest';
import type { WaitingListItemData } from '../models/WaitingListItemData';
import type { WaitingListRegisterRequestData } from '../models/WaitingListRegisterRequestData';
import type { WaitingListSendMessageRequestData } from '../models/WaitingListSendMessageRequestData';
import type { WaitingListSortBy } from '../models/WaitingListSortBy';
import type { WaitingListUpdateRequestData } from '../models/WaitingListUpdateRequestData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WaitingListService {
  /**
   * Register To Waiting List
   * @param requestBody
   * @returns WaitingListItemData Successful Response
   * @throws ApiError
   */
  public static registerToWaitingList(
    requestBody: WaitingListRegisterRequestData,
  ): CancelablePromise<WaitingListItemData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/waiting_list/register',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Waiting List
   * @param eventId
   * @param page Page number
   * @param perPage Items per page
   * @param search Search value
   * @param date Specific Date
   * @param sortBy Sort field
   * @returns WaitingListItemData Successful Response
   * @throws ApiError
   */
  public static getWaitingList(
    eventId?: string | null,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    date?: string,
    sortBy?: WaitingListSortBy,
  ): CancelablePromise<Array<WaitingListItemData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/waiting_list',
      query: {
        event_id: eventId,
        page: page,
        per_page: perPage,
        search: search,
        date: date,
        sort_by: sortBy,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Waiting List Item
   * @param requestBody
   * @returns WaitingListItemData Successful Response
   * @throws ApiError
   */
  public static updateWaitingListItem(
    requestBody: WaitingListUpdateRequestData,
  ): CancelablePromise<WaitingListItemData> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/waiting_list',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Customer Waiting List Items
   * @param email Customer email
   * @param accountId Account ID
   * @returns WaitingListItemData Successful Response
   * @throws ApiError
   */
  public static getCustomerWaitingListItems(
    email: string,
    accountId: string,
  ): CancelablePromise<Array<WaitingListItemData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/waiting_list/customer/by_email',
      query: {
        email: email,
        account_id: accountId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Customer Cancel Waiting List Item
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static customerCancelWaitingListItem(requestBody: CustomerCancelWaitingListRequest): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/waiting_list/customer/cancel',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Send Waiting List Message
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public static sendWaitingListMessage(requestBody: WaitingListSendMessageRequestData): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/waiting_list/send_message',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
